// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608202109/js/" + chunkId + "." + {"44":"3ba2ead4","225":"aaa725c9","481":"12b497f4","486":"3bb050af","770":"a7d99bc0"}[chunkId] + ".0.4527505337997759.chunk.js";
};